import { CardData } from '../types';
import { FEATURES } from '../features';

export type CardTrait = 'odd' | 'even' | 'prime' | 'high' | 'low' | 'negative' | 'curse';

function isPrime(value: number): boolean {
  const n = Math.abs(value);
  if (n < 2) return false;
  for (let i = 2; i * i <= n; i++) {
    if (n % i === 0) return false;
  }
  return true;
}

export function getCardTraits(card: CardData): CardTrait[] {
  if (!FEATURES.cardTraits) return [];
  const traits: CardTrait[] = [];

  if (card.kind === 'curse') {
    traits.push('curse');
    return traits;
  }

  const n = card.number;
  if (Math.abs(n) >= 8) traits.push('high');
  if (Math.abs(n) <= 3) traits.push('low');
  if (n < 0) traits.push('negative');
  if (Math.abs(n) % 2 === 0) traits.push('even');
  else traits.push('odd');
  if (isPrime(n)) traits.push('prime');
  return traits;
}

export function hasTrait(card: CardData, trait: CardTrait): boolean {
  return getCardTraits(card).includes(trait);
}
